import "@fontsource-variable/inter/index.css";
import "@fontsource-variable/roboto/index.css";

import type { DetailedHTMLProps, LinkHTMLAttributes } from "react";

import interVariable from "@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url";
import robotoVariable from "@fontsource-variable/roboto/files/roboto-latin-wght-normal.woff2?url";

export const fonts: Array<DetailedHTMLProps<LinkHTMLAttributes<HTMLLinkElement>, HTMLLinkElement>> = [
	{
		rel: "preload",
		as: "font",
		type: "font/woff2",
		href: robotoVariable,
		crossOrigin: "anonymous",
	},
	{
		rel: "preload",
		as: "font",
		type: "font/woff2",
		href: interVariable,
		crossOrigin: "anonymous",
	},
] as const;
